import { Logger, type TeamRemoveInput, type TeamRemoveSuccess, toResponseError, type TeamData } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTeamCache } from './cache'

const logger = new Logger('useTeams')

type Input = TeamRemoveInput & Pick<TeamData, 'parentId'>

export function useRemoveTeam(): RemoveHookResponse<Input> {
  logger.verbose('calling useRemoveTeam')
  const cache = useTeamCache()
  const mutation = useTantalimMutation<Input, TeamRemoveSuccess>({ url: '/team/remove' })

  async function remove({ parentId, ...input }: Input): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearItem(input.teamId)
      if (parentId) cache.clearItem(parentId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
